module.exports = __webpack_public_path__ + "img/11_noff_close_L1.e3cb4ed6.svg";